// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.StripeSubscriptionForm__Button {
  margin: 0 0.25rem;
}
.StripeSubscriptionForm__Button--Primary {
  color: white;
}
.StripeSubscriptionForm__Select, .StripeSubscriptionForm__Email {
  width: 22rem;
}
.StripeSubscriptionForm__Card {
  padding: 0.5rem;
}
.StripeSubscriptionForm__StripeBadge {
  height: 1.5rem;
}`, "",{"version":3,"sources":["webpack://./libs/data/services/stripe-payment/src/lib/subscription-form/subscription-form.component.scss"],"names":[],"mappings":"AACE;EACE,iBAAA;AAAJ;AAEI;EACE,YAAA;AAAN;AAIE;EAEE,YAAA;AAHJ;AAME;EACE,eAAA;AAJJ;AAOE;EACE,cAAA;AALJ","sourcesContent":[".StripeSubscriptionForm {\n  &__Button {\n    margin: 0 0.25rem;\n\n    &--Primary {\n      color: white;\n    }\n  }\n\n  &__Select,\n  &__Email {\n    width: 22rem;\n  }\n\n  &__Card {\n    padding: 0.5rem;\n  }\n\n  &__StripeBadge {\n    height: 1.5rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
